import React, { useEffect, useState } from 'react';
import { Globe } from 'lucide-react';
import { brand, nav, DOWNLOAD_URL } from '../data/story';

/* Gerçek logo. Krem zeminli opak bir görsel olduğu için
   yuvarlatılmış bir çip içinde gösteriliyor: koyu hero'nun
   üstünde açık kare kaza gibi değil, uygulama ikonu gibi duruyor. */
export function Mark({ size = 30, className = '' }) {
  return (
    <span
      className={`inline-block shrink-0 overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.26,
        boxShadow: '0 1px 0 rgba(255,255,255,.14), 0 4px 14px rgba(0,0,0,.28)',
      }}
    >
      <img
        src="/assets/brand/logo-128.webp"
        alt=""
        aria-hidden="true"
        width={size}
        height={size}
        className="block w-full h-full object-cover"
      />
    </span>
  );
}

/* Header hiçbir zaman büyük menü çubuğu gibi durmaz.
   Altındaki bölüm beyaza dönünce mürekkebe geçer. */
export default function Header() {
  const [paper, setPaper] = useState(false);

  useEffect(() => {
    let raf = null;
    const read = () => {
      raf = null;
      const secs = document.querySelectorAll('[data-paper]');
      setPaper(
        [...secs].some((s) => {
          const b = s.getBoundingClientRect();
          return b.top <= 56 && b.bottom > 56;
        })
      );
    };
    const onScroll = () => {
      if (raf === null) raf = requestAnimationFrame(read);
    };
    read();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf !== null) cancelAnimationFrame(raf);
    };
  }, []);

  const ink = paper ? '#12160F' : '#F7F7F2';

  return (
    <header
      className="fixed top-0 left-0 right-0 z-[90] flex items-center justify-between gap-6 px-[max(20px,4vw)] py-4 transition-colors duration-500"
      style={{ color: ink, mixBlendMode: 'normal' }}
    >
      <a href="#top" className="flex items-center gap-2 font-display font-semibold text-[16px] tracking-tight">
        <Mark size={30} />
        <span>
          {brand.name}
          <span className="opacity-50 ml-1">{brand.suffix}</span>
        </span>
      </a>

      <nav aria-label="Ana menü" className="hidden md:flex items-center gap-7 text-[13px]">
        {nav.links.map((l) => (
          <a key={l.href} href={l.href} className="opacity-70 hover:opacity-100 transition-opacity duration-300">
            {l.label}
          </a>
        ))}
      </nav>

      <div className="flex items-center gap-4">
        <button
          type="button"
          aria-label="Dil"
          className="flex items-center gap-1.5 font-mono text-[11px] tracking-[.1em] opacity-70 hover:opacity-100 transition-opacity duration-300"
        >
          <Globe className="w-3.5 h-3.5" aria-hidden="true" />
          TR
        </button>
        <a
          href={DOWNLOAD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-[13px] font-medium px-4 py-2 rounded-full transition-transform duration-300 hover:-translate-y-0.5"
          style={{ background: '#C8FF22', color: '#0A140A', boxShadow: '0 6px 20px rgba(200,255,34,.25)' }}
        >
          <span className="hidden sm:inline">{nav.cta}</span>
          <span className="sm:hidden">İndir</span>
          <span aria-hidden="true">↓</span>
        </a>
      </div>
    </header>
  );
}
